<template>
  <el-dialog class="k-point-edit-form" title="Загрузка фото" :close-on-click-modal="false" :center="true" :show-close="false" :visible.sync="dialogFormVisible">
    <div class="k-point-edit-form__container">
      <el-row :gutter="20" class="k-point-edit-form__param image-container">
        <img :src="user.imageUrl" class="image">
        <div class="upload-btn-wrapper">
          <button class="btn">Загрузить фото <span v-if="image" class="el-icon-check btn__icon"></span></button>
          <input @change="handleImage" type="file" name="myfile" accept='image/*'/>
        </div>
      </el-row>

      <el-row :gutter="20" class="k-point-edit-form__param">
        <el-button type="success" round @click="handleSave" size="mini">Сохранить</el-button>
        <el-button round @click="handleCancel" size="mini">Отмена</el-button>
      </el-row>
    </div>
    <div v-if="loader" class="overlay">
      <div class="el-icon-loading loader"></div>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'k-user-image-form',

  props: {
    dialogFormVisible: {
      type: Boolean,
      required: true,
    },
    imageUpload: {
      type: String,
    },
    user: {
      type: Object,
    },
  },

  data() {
    return {
      image: '',
      loader: false,
    };
  },

  created() {},

  methods: {
    // Отмена редактирования
    handleCancel() {
      this.$emit('cancel');
    },

    // Сохранение
    async handleSave() {
      this.loader = true;
      const image = {
        id: this.imageUpload,
        image: this.image,
      };

      console.log('image', image);

      await this.setImage(image);
      this.loader = false;
      this.image = '';
      this.$emit('cancel');
    },

    handleImage(e) {
      const selectedImage = e.target.files[0];
      this.createBase64Image(selectedImage);
    },

    createBase64Image(fileObject) {
      const reader = new FileReader();
      reader.onload = (e) => {
        // eslint-disable-next-line
        this.image = e.target.result.split(',')[1];
      };
      reader.readAsDataURL(fileObject);
    },

    ...mapActions({
      setImage: 'user/setImage',
    }),
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.k-point-edit-form {
  $this: &;
  $icon-size: 50px;

  text-align: left;

  &__container {
    padding: 0 20px;
  }

  &__title {
    margin-bottom: 2 * $vp;
  }

  &__param {
    margin-bottom: $vp;
  }

  .image-container {
    display: flex;
    flex-flow: column;
    align-items: center;
  }

  .image {
    width: 400px;
    display: block;
  }

  .upload-btn-wrapper {
    position: relative;
    overflow: hidden;
    display: inline-block;
    margin: 15px 0;
  }

  .btn {
    color: white;
    background-color: rgb(17, 106, 207);
    padding: 8px 20px;
    border: 0;
    border-radius: 25px;

    &__icon {
      font-weight: bold;
    }
  }

  .upload-btn-wrapper input[type=file] {
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
  }

  .loader {
    position: absolute;
    font-size: 100px;
    top: 40%;
    left: 45%;
    color: white;
  }

  .overlay {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: #00000094;
  }
}
</style>
